import Vue from 'vue'   //引入Vue
import Router from 'vue-router'  //引入vue-router
//import Hello from '@/components/Hello'  //引入根目录下的Hello.vue组件

Vue.use(Router)  //Vue全局使用Router
//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const constantRoutes = [
    {
        path: '/',
        redirect: '/home'
    },
    {
        path: '/login',
        component: () => import('@/views/login/index.vue'),
    },
    {
        path: '/source',
        component: () => import('@/views/source/index.vue'),
    },
    {
        path: '/systemMenu',
        component: () => import('@/views/systemMenu/index.vue'),
        redirect: 'messageNotification',
        children: [
            {
                path: '/messageNotification',
                name: 'messageNotification',
                component: () =>
                    import('@/views/systemMenu/messageNotification/index.vue'),
            },
            {
                path: '/enclosureManagemen',
                name: 'enclosureManagemen',
                component: () =>
                    import('@/views/systemMenu/enclosureManagemen/index.vue'),
            },
            {
                path: '/animalModel',
                name: 'animalModel',
                component: () =>
                    import('@/views/animalModel/index.vue'),
            },
            {
                path: '/animalModel/BodySize/:id',
                name: 'BodySize',
                component: () =>
                    import('@/views/animalModel/BodySize/index.vue'),
            },
            {
                path: '/animalModel/Product/:id',
                name: 'Product',
                component: () =>
                    import('@/views/animalModel/Product/index.vue'),
            },
            {
                path: '/Breeding',
                name: 'Breeding',
                component: () =>
                    import('@/views/Farming/Breeding/index.vue'),
            },
            {
                path: '/Breeding/Childbirth/:id',
                name: 'Childbirth',
                component: () =>
                    import('@/views/Farming/Breeding/Childbirth/index.vue'),
            },
            {
                path: '/Consume',
                name: 'Consume',
                component: () =>
                    import('@/views/Farming/Consume/index.vue'),
            },
            {
                path: '/Feed',
                name: 'Feed',
                component: () =>
                    import('@/views/Farming/Feed/index.vue'),
            },
            {
                path: '/LeavingFence',
                name: 'LeavingFence',
                component: () =>
                    import('@/views/Farming/LeavingFence/index.vue'),
            },
            {
                path: '/Oestrus',
                name: 'Oestrus',
                component: () =>
                    import('@/views/Farming/Oestrus/index.vue'),
            },
            {
                path: '/TransferColumn',
                name: 'TransferColumn',
                component: () =>
                    import('@/views/Farming/TransferColumn/index.vue'),
            },
            {
                path: '/PregnancyExamination',
                name: 'PregnancyExamination',
                component: () =>
                    import('@/views/Farming/PregnancyExamination/index.vue'),
            },

            {
                path: '/plantBreeding',
                name: 'plantBreeding',
                component: () =>
                    import('@/views/plantBreeding/index.vue'),
            },
            {
                path: '/GrowthImaging',
                name: 'GrowthImaging',
                component: () =>
                    import('@/views/GrowthImaging/index.vue'),
            },

            {
                path: '/ProductionTeam',
                name: 'ProductionTeam',
                component: () =>
                    import('@/views/ProductionTeam/index.vue'),
            },



            {
                path: '/column',
                name: 'column',
                component: () =>
                    import('@/views/column/index.vue'),
            }, {
                path: '/choker',
                name: 'choker',
                component: () =>
                    import('@/views/choker/index.vue'),
            }, {
                path: '/gatewayNode',
                name: 'gatewayNode',
                component: () =>
                    import('@/views/gatewayNode/index.vue'),
            }, {
                path: '/controlPanel',
                name: 'controlPanel',
                component: () =>
                    import('@/views/controlPanel/index.vue'),
                props: true
            }, {
                path: '/video',
                name: 'video',
                component: () =>
                    import('@/views/video/index.vue'),
            }, {
                path: '/controlPanel/panelChannel/:id',
                name: 'panelChannel',
                component: () =>
                    import('@/views//controlPanel/panelChannel.vue'),
                props: true
            },
            {
                path: '/SalesManagement',
                name: 'SalesManagement',
                component: () =>
                    import('@/views/systemMenu/SalesManagement/index.vue'),
            },
            {
                path: '/SalesHistory',
                name: 'SalesHistory',
                component: () =>
                    import('@/views/systemMenu/SalesHistory/index.vue'),
            },
            {
                path: '/PersonnelManagement',
                name: 'PersonnelManagement',
                component: () =>
                    import('@/views/systemMenu/PersonnelManagement/index.vue'),
            },
            {
                path: '/MaterialTypeManagement',
                name: 'MaterialTypeManagement',
                component: () =>
                    import('@/views/basicData/MaterialTypeManagement/index.vue'),
            },

            {
                path: '/ExpertManagement',
                name: 'ExpertManagement',
                component: () =>
                    import('@/views/expert/index.vue'),
            },
            {
                path: '/ExpertManagement/ExpertSharing/:id',
                name: 'ExpertSharing',
                component: () =>
                    import('@/views/expert/ExpertSharing/index.vue'),
            },
            {
                path: '/Knowledges',
                name: 'Knowledges',
                component: () =>
                    import('@/views/expert/Knowledges/index.vue'),
            },
            {
                path: '/AnimalSpecies',
                name: 'AnimalSpecies',
                component: () =>
                    import('@/views/basicData/AnimalSpecies/index.vue'),
            },
            {
                path: '/ChannelType',
                name: 'ChannelType',
                component: () =>
                    import('@/views/basicData/ChannelType/index.vue'),
            },
            {
                path: '/MaterialStock',
                name: 'MaterialStock',
                component: () =>
                    import('@/views/material/Stock/index.vue'),
            },
            {
                path: '/MaterialStock/Add/:id',
                name: 'MaterialStockAdd',
                component: () =>
                    import('@/views/material/Add/index.vue'),
            },
            {
                path: '/MaterialStock/Reduce/:id',
                name: 'MaterialStockReduce',
                component: () =>
                    import('@/views/material/Reduce/index.vue'),
            },
            {
                path: '/Vaccination',
                name: 'Vaccination',
                component: () =>
                    import('@/views/Farming/Vaccination/index.vue'),
            },
            {
                path: '/Vaccination/list/:id',
                name: 'VaccinationList',
                component: () =>
                    import('@/views/Farming/Vaccination/list.vue'),
            },
            {
                path: '/WarningPolicy',
                name: 'WarningPolicy',
                component: () =>
                    import('@/views/equipment/WarningPolicy/index.vue'),
            },
            {
                path: '/WarningRecord',
                name: 'WarningRecord',
                component: () =>
                    import('@/views/equipment/WarningRecord/index.vue'),
            },
            {
                path: '/WarningRule',
                name: 'WarningRule',
                component: () =>
                    import('@/views/equipment/WarningRule/index.vue'),
            },

            {
                path: '/ControlLogs',
                name: 'ControlLogs',
                component: () =>
                    import('@/views/equipment/ControlLogs/index.vue'),
            },
            {
                path: '/HisData',
                name: 'HisData',
                component: () =>
                    import('@/views/equipment/HisData/index.vue'),
            },
            {
                path: '/LocalDevices',
                name: 'LocalDevices',
                component: () =>
                    import('@/views/equipment/LocalDevices/index.vue'),
            },

            {
                path: '/Commodity',
                name: 'Commodity',
                component: () =>
                    import('@/views/commodity/index.vue'),
            },
            {
                path: '/CommodityType',
                name: 'CommodityType',
                component: () =>
                    import('@/views/commodity/CommodityType/index.vue'),
            },



            {
                path: '/EnterPrise',
                name: 'EnterPrise',
                component: () =>
                    import('@/views/sys/EnterPrise/index.vue'),
            },
            {
                path: '/User',
                name: 'User',
                component: () =>
                    import('@/views/sys/User/index.vue'),
            },

            {
                path: '/MonitorIndex',
                name: 'MonitorIndex',
                component: () =>
                    import('@/views/basicData/MonitorIndex/index.vue'),
            },

            {
                path: '/ElectronicFence',
                name: 'ElectronicFence',
                component: () =>
                    import('@/views/equipment/ElectronicFence/index.vue'),
            },
            {
                path: '/ElectronicFencePoints',
                name: 'ElectronicFencePoints',
                component: () =>
                    import('@/views/equipment/ElectronicFencePoints/index.vue'),
            },

            {
                path: '/ChokerData',
                name: 'ChokerData',
                component: () =>
                    import('@/views/equipment/ChokerData/index.vue'),
            },
            {
                path: '/Work',
                name: 'Work',
                component: () =>
                    import('@/views/Farming/Work/index.vue'),
            },
            {
                path: '/SourceTracing',
                name: 'SourceTracing',
                component: () =>
                    import('@/views/SourceTracing/index.vue'),
            },
            {
                path: '/SourceTracingLog',
                name: 'SourceTracingLog',
                component: () =>
                    import('@/views/SourceTracing/SourceTracingLog/index.vue'),
            }
        ]
    },
    {
        path: '/home',
        component: () => import('@/views/home/index.vue'),
        redirect: 'BreedingPark',
        children: [
            {
                path: '/BreedingPark',
                name: 'BreedingPark',
                component: () =>
                    import('@/views/home/BreedingPark/index.vue'),
            },
            {
            path: '/oTCenter',
            name: 'oTCenter',
            component: () =>
                import('@/views/home/oTCenter/index.vue'),
        },
            {
                path: '/environmentalMonitoring',
                name: 'environmentalMonitoring',
                component: () =>
                    import('@/views/home/environmentalMonitoring/index.vue'),
            },
            // {
            //   path: '/environmentalMonitoring',
            //   name: 'environmentalMonitoring',
            //   component: () =>
            //   import('@/views/home/environmentalMonitoring/index.vue'),
            // },
            {
                path: '/breedingManagement',
                name: 'breedingManagement',
                component: () =>
                    import('@/views/home/breedingManagement/index.vue'),
            },
            {
                path: '/TraceabilityCenter',
                name: 'TraceabilityCenter',
                component: () =>
                    import('@/views/home/TraceabilityCenter/index.vue'),
            },
            {
                path: '/videoCenter',
                name: 'videoCenter',
                component: () =>
                    import('@/views/home/videoCenter/index.vue'),
            },
            {
                path: '/industrialPark',
                name: 'industrialPark',
                component: () =>
                    import('@/views/home/industrialPark/index.vue'),
            },
            {
                path: '/MonitoringCenter',
                name: 'MonitoringCenter',
                component: () =>
                    import('@/views/home/MonitoringCenter/index.vue'),
            },
            {
                path: '/OnlineTrading',
                name: 'OnlineTrading',
                component: () =>
                    import('@/views/home/OnlineTrading/index.vue'),
            },
            {
                path: '/EpidemicPrevention',
                name: 'EpidemicPrevention',
                component: () =>
                    import('@/views/home/EpidemicPrevention/index.vue'),
            },

        ]
    }

]
const router = new Router({
    mode: 'history', // require service support
    // scrollBehavior: () => ({
    //   y: 0
    // }),
    routes: constantRoutes
})
// 全局前置守卫
router.beforeEach((to, from, next) => {
    // 获取用户的 token，这里假设你是从 localStorage 或其他地方获取它
    const token = localStorage.getItem('token');
    // 登录判断
    if (token) {
        if (to.path === '/login') {
            next({path: '/'})
        } else {
            // 权限判断
            next()
        }
    } else {
        if (to.path === '/login' || to.path === '/source') {
            next()
        } else {
            next('/login')
        }
    }
});


export default router
